import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SideNavItem = ({ iconClassName = '', text = '', className = '', onClick = () => { }, active = false, disabled = false, labelNewUntil = new Date(), iconName = '', visible = true }) => {
  const now = new Date();
  const displayNewLabel = now.getTime() < labelNewUntil.getTime();

  const sideNavItemClass = classNames(className, {
    'side-nav-item': true,
    'side-nav-item--active': active,
    'side-nav-item--disabled': disabled,
    'side-nav-item--new': displayNewLabel
  });

  const onClickHandler = (e) => {
    if (!disabled) {
      onClick(e);
    }
  };

  if (!visible) {
    return null;
  }
  return (
    <div className={sideNavItemClass} onClick={onClickHandler} data-test-id="side-nav-item">
      {!iconName && <span className={`side-nav-item__icon ${iconClassName}`} />}
      {iconName && <span className="side-nav-item__icon"><img src={`assets/icons/${iconName}.svg`} /></span>}
      <span className="side-nav-item__text">{text}</span>
    </div>
  );
};

SideNavItem.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconClassName: PropTypes.string,
  iconName: PropTypes.string,
  labelNewUntil: PropTypes.instanceOf(Date),
  onClick: PropTypes.func,
  text: PropTypes.string,
  visible: PropTypes.bool,
};

export default SideNavItem;
